import React, { useEffect, useMemo, useState } from 'react';
import useMedia from '../hooks/useMedia';
import MediaPickerModal from './MediaPickerModal';
import '../styles/media-picker.css';

const videoLink = (item) => {
  const files = Array.isArray(item?.video_files) ? item.video_files : [];
  return files[0]?.link || '';
};

export default function MediaPicker({ type = 'photo', value, onChange }) {
  const [open, setOpen] = useState(false);
  const [draftItem, setDraftItem] = useState(value || null);

  const {
    items,
    loading,
    error,
    hasMore,
    query,
    orientation,
    type: currentType,
    search,
    loadMore,
    setType,
    setOrientation,
  } = useMedia({ initialQuery: 'marketing', initialType: type });

  const selected = useMemo(() => draftItem || value || null, [draftItem, value]);

  useEffect(() => {
    setType(type);
  }, [setType, type]);

  useEffect(() => {
    if (open && !items.length) {
      search(query || 'marketing');
    }
  }, [items.length, open, query, search]);

  useEffect(() => {
    setDraftItem(value || null);
  }, [value]);

  return (
    <div className="mp-media-picker">
      <button type="button" className="mp-media-picker__trigger" onClick={() => setOpen((prev) => !prev)}>
        {selected ? (
          <span className="mp-media-picker__selected">
            <img src={selected.thumb || selected.small || selected.medium || selected.large} alt={selected.author || 'Mídia selecionada'} loading="lazy" />
            <strong>{selected.type === 'video' ? 'Vídeo' : 'Foto'} · {selected.author || 'Pexels'}</strong>
          </span>
        ) : (
          <span>Selecionar Mídia</span>
        )}
      </button>

      <MediaPickerModal
        open={open}
        query={query}
        type={currentType}
        orientation={orientation}
        items={items}
        loading={loading}
        error={error}
        selectedItem={selected}
        hasMore={hasMore}
        onSearch={search}
        onTypeChange={(nextType) => {
          setType(nextType);
          search(query || 'marketing');
        }}
        onOrientationChange={(nextOrientation) => {
          setOrientation(nextOrientation);
          search(query || 'marketing');
        }}
        onSelect={(item) => setDraftItem(item)}
        onLoadMore={loadMore}
        onCancel={() => {
          setDraftItem(value || null);
          setOpen(false);
        }}
        onApply={() => {
          if (draftItem) {
            onChange?.({
              ...draftItem,
              media_url: draftItem.type === 'video' ? videoLink(draftItem) : (draftItem.large || draftItem.original || draftItem.medium || draftItem.small || draftItem.thumb),
              media_author: draftItem.author || 'Pexels',
            });
          }
          setOpen(false);
        }}
      />
    </div>
  );
}
